export const isPrimitiveValue = (value) => {
    return "initialValue" in value;
};
export const isDerivedValue = (value) => {
    return "derive" in value && typeof value.derive === "function";
};
//# sourceMappingURL=value.js.map